/** @format */
import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export function SendIcon({ ic }: {ic: string }) {
	return (
		<SvgIcon className={ic}>
			<path d='M24,3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V24H24ZM2,3A1,1,0,0,1,3,2H21a1,1,0,0,1,1,1V22H2Z' />
			<path d='M14.431,13.4,9.719,18.106,8.305,16.692l4.712-4.712L8.344,7.308,9.758,5.894l4.673,4.672a2,2,0,0,1,0,2.829Z' />
		</SvgIcon>
	);
}


export function GithubIcon({ ic }: {ic: string }) {
	return (
		<a href='https://github.com/cnqso/spirals' target='_blank' rel='noreferrer' className={ic}>
			<SvgIcon sx={{fontSize: '1em'}}>
				<path d='M12,0.296c-6.627,0-12,5.372-12,12c0,5.302,3.438,9.8,8.206,11.387   c0.6,0.111,0.82-0.26,0.82-0.577c0-0.286-0.011-1.231-0.016-2.234c-3.338,0.726-4.043-1.416-4.043-1.416   C4.421,18.069,3.635,17.7,3.635,17.7c-1.089-0.745,0.082-0.729,0.082-0.729c1.205,0.085,1.839,1.237,1.839,1.237   c1.07,1.834,2.807,1.304,3.492,0.997C9.156,18.429,9.467,17.9,9.81,17.6c-2.665-0.303-5.467-1.332-5.467-5.93   c0-1.31,0.469-2.381,1.237-3.221C5.455,8.146,5.044,6.926,5.696,5.273c0,0,1.008-0.322,3.301,1.23   C9.954,6.237,10.98,6.104,12,6.099c1.02,0.005,2.047,0.138,3.006,0.404c2.29-1.553,3.297-1.23,3.297-1.23   c0.653,1.653,0.242,2.873,0.118,3.176c0.769,0.84,1.235,1.911,1.235,3.221c0,4.609-2.807,5.624-5.479,5.921   c0.43,0.372,0.814,1.103,0.814,2.222c0,1.606-0.014,2.898-0.014,3.293c0,0.319,0.216,0.694,0.824,0.576   c4.766-1.589,8.2-6.085,8.2-11.385C24,5.669,18.627,0.296,12,0.296z' />
				<path d='M4.545,17.526c-0.026,0.06-0.12,0.078-0.206,0.037c-0.087-0.039-0.136-0.121-0.108-0.18   c0.026-0.061,0.12-0.078,0.207-0.037C4.525,17.384,4.575,17.466,4.545,17.526L4.545,17.526z' />
				<path d='M5.031,18.068c-0.057,0.053-0.169,0.028-0.245-0.055c-0.079-0.084-0.093-0.196-0.035-0.249   c0.059-0.053,0.167-0.028,0.246,0.056C5.076,17.903,5.091,18.014,5.031,18.068L5.031,18.068z' />
				<path d='M5.504,18.759c-0.074,0.051-0.194,0.003-0.268-0.103c-0.074-0.107-0.074-0.235,0.002-0.286   c0.074-0.051,0.193-0.005,0.268,0.101C5.579,18.579,5.579,18.707,5.504,18.759L5.504,18.759z' />
				<path d='M6.152,19.427c-0.066,0.073-0.206,0.053-0.308-0.046c-0.105-0.097-0.134-0.234-0.068-0.307   c0.067-0.073,0.208-0.052,0.311,0.046C6.191,19.217,6.222,19.355,6.152,19.427L6.152,19.427z' />
				<path d='M7.047,19.814c-0.029,0.094-0.164,0.137-0.3,0.097C6.611,19.87,6.522,19.76,6.55,19.665   c0.028-0.095,0.164-0.139,0.301-0.096C6.986,19.609,7.075,19.719,7.047,19.814L7.047,19.814z' />
				<path d='M8.029,19.886c0.003,0.099-0.112,0.181-0.255,0.183c-0.143,0.003-0.26-0.077-0.261-0.174c0-0.1,0.113-0.181,0.256-0.184   C7.912,19.708,8.029,19.788,8.029,19.886L8.029,19.886z' />
				<path d='M8.943,19.731c0.017,0.096-0.082,0.196-0.224,0.222c-0.139,0.026-0.268-0.034-0.286-0.13   c-0.017-0.099,0.084-0.198,0.223-0.224C8.797,19.574,8.925,19.632,8.943,19.731L8.943,19.731z' />
			</SvgIcon>
		</a>
	);
}

export function WebsiteIcon({ ic }: {ic: string }) {
	return (
		<a href='https://cnqso.github.io/#/Blog/post/spirals' target='_blank' rel='noreferrer' className={ic}>
			<SvgIcon sx={{fontSize: '1em'}}>
				<path d='M21,2H3C1.35,2,0,3.35,0,5V22H24V5c0-1.65-1.35-3-3-3ZM3,4H21c.55,0,1,.45,1,1v2H2v-2c0-.55,.45-1,1-1Zm-1,16V9H22v11H2Zm2-9h6v2h-2v5h-2v-5h-2v-2Zm8,0h7v2h-7v-2Zm0,4h7v2h-7v-2Z' />
			</SvgIcon>
		</a>
	);
}

export function Locked({ ic }: {ic: string }) {
	return (

		<span>
			<SvgIcon sx={{fontSize: '1.05em'}}>
				<path d='M19,8V7A7,7,0,0,0,5,7V8H2V21a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V8ZM7,7A5,5,0,0,1,17,7V8H7ZM20,21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V10H20Z' />
				<rect x='11' y='14' width='2' height='4' />
			</SvgIcon>
		</span>
	);
}

export function Unlocked({ ic }: { ic: string }) {
	return (
		<span>
			<SvgIcon sx={{fontSize: '1.05em'}}>
				<path d='M7,8V7a5,5,0,0,1,9.375-2.422l1.749-.971A7,7,0,0,0,5,7V8H2V21a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V8ZM20,21a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V10H20Z' />
				<rect x='11' y='14' width='2' height='4' />
			</SvgIcon>
		</span>
	);
}

export function Grid({ ic }: { ic: string }) {
	return (
		<span>
			<SvgIcon sx={{fontSize: '1em'}} className={ic}>
			<path d="M4.5,19.5V22H3a1,1,0,0,1-1-1V19.5H4.5m2-2H0V21a3,3,0,0,0,3,3H6.5V17.5Z"/><path d="M22,19.5V21a1,1,0,0,1-1,1H19.5V19.5H22m2-2H17.5V24H21a3,3,0,0,0,3-3V17.5Z"/><path d="M4.5,10.75v2.5H2v-2.5H4.5m2-2H0v6.5H6.5V8.75Z"/><path d="M22,10.75v2.5H19.5v-2.5H22m2-2H17.5v6.5H24V8.75Z"/><path d="M4.5,2V4.5H2V3A1,1,0,0,1,3,2H4.5m2-2H3A3,3,0,0,0,0,3V6.5H6.5V0Z"/><path d="M13.25,19.5V22h-2.5V19.5h2.5m2-2H8.75V24h6.5V17.5Z"/><path d="M13.25,10.75v2.5h-2.5v-2.5h2.5m2-2H8.75v6.5h6.5V8.75Z"/><path d="M13.25,2V4.5h-2.5V2h2.5m2-2H8.75V6.5h6.5V0Z"/><path d="M21,2a1,1,0,0,1,1,1V4.5H19.5V2H21m0-2H17.5V6.5H24V3a3,3,0,0,0-3-3Z"/>
			</SvgIcon>
		</span>
	);
}
export function Plot({ linear }: { linear: number }) {
	return (
		<span>
			<SvgIcon sx={{fontSize: '1em'}}>
				{(linear-1) ? <path d="M3,22H24v2H3c-1.654,0-3-1.346-3-3V0H2V21c0,.551,.449,1,1,1ZM17,5v2h3.586l-5.586,5.586-4-4-6.707,6.707,1.414,1.414,5.293-5.293,4,4,7-7v3.586h2V5h-7Z"/>
			
			: <path d="M23.988,24H2.988C1.333,24-.012,22.654-.012,21V0H1.988V21c0,.552,.449,1,1,1H23.988v2ZM14,13c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Zm6-6c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Zm-9,11c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Zm9-1c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1ZM9,5c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Zm-4,7c0,.552,.448,1,1,1s1-.448,1-1-.448-1-1-1-1,.448-1,1Z"/>
			}</SvgIcon>
		</span>
	);
}

export function Graph({ ic }: { ic: string }) {
	return (
		<span>
			<SvgIcon sx={{fontSize: '1em'}} className={ic}>
			<path d="M3,22H24v2H3c-1.654,0-3-1.346-3-3V0H2V21c0,.551,.449,1,1,1ZM17,5v2h3.586l-5.586,5.586-4-4-6.707,6.707,1.414,1.414,5.293-5.293,4,4,7-7v3.586h2V5h-7Z"/>
			</SvgIcon>
		</span>
	);
}